module.exports = __webpack_public_path__ + "img/07.cd8c6be6.jpg";